<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-trainings">

        <page-title :title="'Szkolenia'" :back="true" :routeName="'Knowledge'"></page-title>

        <card-training-progress></card-training-progress>

        <page-title :title="'Lekcje'" :back="false"></page-title>

        <trainings-segment></trainings-segment>

        <div v-for="(item,index) in lessons" :key="item.slug">
            <item-training
                    :index="index+1"
                    :slug="item.slug"
                    :title="item.title"
                    :excerpt="item.excerpt"
                    :time="item.time"
                    :content="item.subtitle"
                    :image="item.image"
                    :done="item.passed_test"
                    :has_steps="item.has_steps"
                    :disabled="item.disabled">
            </item-training>
        </div>

        <page-title :title="'Egzaminy'" :back="false" class="mt-20"></page-title>

        <div v-for="(item,index) in levels">
            <item-training-exam
                    v-if="category === 'all' ? true : category === item.slug"
                    :index="index+1"
                    :slug="item.exam.slug"
                    :level_slug="item.slug"
                    :name="item.exam.name"
                    :image="item.exam.image"
                    :passed="item.exam.passed"
                    :available="item.exam.available">
            </item-training-exam>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';

    import PageTitle from '@/components/PageTitle.vue';
    import CardTrainingProgress from '@/cards/CardTrainingProgress.vue';

    import ItemTraining from '@/items/ItemTraining';
    import ItemTrainingExam from '@/items/ItemTrainingExam';
    import TrainingsSegment from '@/navs/TrainingsSegment';

    export default {
        name: 'TrainingsIndex',
        components: {
          PageTitle,
          CardTrainingProgress,
          ItemTraining,
          ItemTrainingExam,
          TrainingsSegment
        },
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters('profile', ['getProfile']),
            ...mapState({
                loading: state => state.trainings.loading,
                category: state => state.trainings.category,
                levels: state => state.trainings.levels,
                lessons: state => state.trainings.lessons
            })
        },
        mounted(){
            this.getLevels().then(() => {
                this.show = true;
            });
        },
        methods: {
            async getLevels() {
                // fetch trainings if no data
                if(!this.levels.length){
                    await this.$store.dispatch('trainings/KNOWLEDGE_TRAININGS_REQUEST');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-header{
        --background: #ffffff
    }
</style>

